/* Winkelwagen van SURGE Pept.
   Stond in het instellingenveld custom_liquid van templates/cart.json, maar
   dat veld mag van Shopify niet groter zijn dan 50 kB. De paar waarden die
   uit Liquid moeten komen staan op window.SP en worden daar vlak voor dit
   bestand ingevuld. */
(function(){
var SP = window.SP || {};
var CFG = {
freeShipThreshold: SP.thresh,
gift10mlHandle: 'bac-water-10ml-bacteriostatic-water-gift',
gift3mlHandle : 'bac-water-3ml-bacteriostatic-water-gift',
gift10mlId : SP.gift10mlId,
gift3mlId  : SP.gift3mlId,
gift10mlWas: SP.gift10mlWas,
gift3mlWas : SP.gift3mlWas,
countBundlesAsVials: false,
excludeHandles: [
'bac-water-10ml-bacteriostatic-water',
'bac-water-3ml-bacteriostatic-water',
'aa-water-3ml-acetic-acid-water'
]
};
if(!document.querySelector('.sp-cb')) return;
var ROWSEL='.cart-item, tr.cart-item';
var BADGESEL='[class*="count"],[class*="Count"],[class*="bubble"],[class*="Bubble"],[class*="badge"],[class*="Badge"],[class*="qty"],[class*="Qty"]';
var SUM = document.getElementById('spSummary');
var configured = CFG.gift10mlHandle.indexOf('REPLACE')===-1 && CFG.gift3mlHandle.indexOf('REPLACE')===-1;
var IMG = SP.img;
function money(c){ var p=(Math.round(c)/100).toFixed(2).split('.'); return '\u20ac'+p[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.')+','+p[1]; }
function excluded(h){ return CFG.excludeHandles.indexOf(h)>-1 || h===CFG.gift10mlHandle || h===CFG.gift3mlHandle; }
function readCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }
function isBundle(it){ return it.product_type==='Bundle' || (it.handle&&it.handle.indexOf('bundle')>-1); }
function vialCount(cart){ var n=0; cart.items.forEach(function(it){ if(excluded(it.handle)) return; if(!CFG.countBundlesAsVials && isBundle(it)) return; n+=it.quantity; }); return n; }
function bundleCount(cart){ var n=0; cart.items.forEach(function(it){ if(isBundle(it)) n+=it.quantity; }); return n; }
function giftsFor(cart){ var v=vialCount(cart), b=bundleCount(cart); return { v:v, b:b, w10:(v>=3?1:0), w3:(v>=3?Math.floor(v/3)-1:0) }; }
function qtyOf(cart,h){ var n=0; cart.items.forEach(function(it){ if(it.handle===h) n+=it.quantity; }); return n; }
function variantId(h){ return fetch('/products/'+h+'.js',{headers:{'Accept':'application/json'}}).then(function(r){ if(!r.ok) throw 0; return r.json(); }).then(function(p){ return p.variants[0].id; }); }
function giftId(h){
/* Het variant-nummer staat in de instellingen, uit Liquid. Alleen als dat om
   wat voor reden ook leeg is halen we het alsnog op. */
var id = (h===CFG.gift10mlHandle) ? CFG.gift10mlId : CFG.gift3mlId;
return (id>0) ? Promise.resolve(id) : variantId(h);
}
function POST(url,body){ return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){ if(!r.ok) throw 0; return r.json(); }); }
function geldigeWagen(o){
/* Niet elk antwoord van Shopify is een winkelwagen. /cart/add.js geeft alleen
   de toegevoegde regel terug. Zo'n antwoord op het scherm zetten levert lege
   aantallen en NaN op, dus het wordt hier tegengehouden. */
return !!(o && typeof o.total_price==='number' && typeof o.item_count==='number' && Array.isArray(o.items));
}
function giftPrijs(cart,h){ var p=0; cart.items.forEach(function(it){ if(it.handle===h && it.price>p) p=it.price; }); return p; }
function syncGifts(cart,w10,w3){
/* Alles via /cart/update.js: dat kan toevoegen, wijzigen en weghalen, en geeft
   de complete wagen terug. Beide cadeaus in een enkel verzoek.

   Een cadeauregel met een prijs boven nul komt uit een wagen van voor de
   prijswijziging. Die moet er eerst uit, anders blijft de oude prijs staan. */
return Promise.all([giftId(CFG.gift10mlHandle),giftId(CFG.gift3mlHandle)]).then(function(ids){
var id10=ids[0], id3=ids[1];
var weg={}, oud=false;
if(id10 && giftPrijs(cart,CFG.gift10mlHandle)>0){ weg[id10]=0; oud=true; }
if(id3 && giftPrijs(cart,CFG.gift3mlHandle)>0){ weg[id3]=0; oud=true; }
var eerst = oud ? POST('/cart/update.js',{updates:weg}) : Promise.resolve(null);
return eerst.then(function(na){
var nu = geldigeWagen(na) ? na : cart;
var wil={}, nodig=false;
if(id10 && qtyOf(nu,CFG.gift10mlHandle)!==w10){ wil[id10]=w10; nodig=true; }
if(id3 && qtyOf(nu,CFG.gift3mlHandle)!==w3){ wil[id3]=w3; nodig=true; }
if(!nodig) return oud ? nu : null;
return POST('/cart/update.js',{updates:wil});
});
}).catch(function(){ return null; });
}
function updateUI(cart, vials, w10, w3){
lastCart=cart;
var cb=document.querySelector('.sp-cb'); if(cb){ cb.style.display = cart.item_count>0 ? '' : 'none'; }
var total=cart.total_price;
var pct= total<=0 ? 0 : Math.max(6,Math.min(100,Math.round(total/CFG.freeShipThreshold*100)));
var unlocked = total>=CFG.freeShipThreshold;
var fillRect=document.querySelector('.sp-ship__fill'); if(fillRect) fillRect.setAttribute('width', unlocked?100:pct);
var gradEnd=document.querySelector('.sp-grad-end'); if(gradEnd) gradEnd.setAttribute('stop-color', unlocked?'#3DDC84':'#FF2E7E');
var ship=document.querySelector('.sp-ship'), st=document.querySelector('.sp-ship__t');
if(st){
if(total>=CFG.freeShipThreshold){ ship.classList.add('is-unlocked');
st.innerHTML='<svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg><b>Free shipping unlocked</b>'; }
else { ship.classList.remove('is-unlocked');
st.innerHTML='<svg viewBox="0 0 24 24"><path d="M1 3h15v13H1zM16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="18.5" cy="18.5" r="2"/></svg>You\'re <span class="amt">'+money(CFG.freeShipThreshold-total)+'</span>&nbsp;from <b>free shipping</b>'; }
}
var g=document.querySelector('.sp-gift');
if(g){
var giftSvg='<svg viewBox="0 0 24 24"><rect x="3" y="8" width="18" height="13" rx="2"/><path d="M12 8v13M3 12h18M12 8s-1-5-4-5-3 5 4 5c7 0 4-5 4-5"/></svg>';
if(w10>0||w3>0){
var parts=[]; if(w10) parts.push(w10+'\u00d7 10ml'); if(w3) parts.push(w3+'\u00d7 3ml');
var extra='';
g.innerHTML=giftSvg+'<div><b>Gift unlocked!</b> Free BAC Water: '+parts.join(' + ')+'.'+extra+'</div>'; g.hidden=false; }
else if(vials>0){ var need=3-vials;
g.innerHTML=giftSvg+'<div>Add <b>'+need+'</b> more '+(need===1?'vial':'vials')+' to unlock a <b>free 10ml BAC Water</b>.</div>'; g.hidden=false; }
else { g.hidden=true; }
}
paintBackgrounds(cart);
if(!window.__spRepaint){ window.__spRepaint=1;
window.addEventListener('load',function(){ try{ paintBackgrounds(cart); }catch(e){} });
setTimeout(function(){ try{ paintBackgrounds(cart); }catch(e){} },700); }
updateHeaderCount(cart);
if(!isQuiet()){ tagGiftLines(); swapImages(); addRuo(); placeTrust(); }
renderDiscounts(cart);
placeSummary();
updateSummary(cart);
}
var TRUST_INNER='<span class="it"><svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="M9 12l2 2 4-4"></path></svg>COA per batch</span><span class="it"><svg viewBox="0 0 24 24"><path d="M3 12h4l3 8 4-16 3 8h4"></path></svg>\u226599% HPLC purity</span><span class="it"><svg viewBox="0 0 24 24"><path d="M21 16V8a2 2 0 0 0-1-1.7l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.7l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path></svg>Discreet shipping</span><span class="it"><svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="10" rx="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>Secure checkout</span>';
function placeTrust(){
if(document.querySelector('.sp-trust--foot')) return;
var anchor=document.getElementById('main-cart-footer')||document.querySelector('.cart__footer');
if(!anchor||!anchor.parentNode) return;
var el=document.createElement('div'); el.className='sp-trust sp-trust--foot'; el.innerHTML=TRUST_INNER;
anchor.parentNode.insertBefore(el, anchor.nextSibling);
}
var lastCart=null;
function summaryPlaced(){ return !!(SUM && SUM.dataset.placed==='1' && SUM.parentNode && document.body.contains(SUM)); }
function summaryLive(){ return summaryPlaced(); }
function syncSummaryClass(){
var live = summaryPlaced() && !SUM.hidden;
document.querySelectorAll('#main-cart-footer .totals, .cart__footer .totals').forEach(function(el){
if(live && SUM.parentNode===el.parentNode){ el.style.display='none'; }
else { el.style.removeProperty('display'); }
});
}
function placeSummary(){
if(!SUM){ SUM=document.getElementById('spSummary'); }
if(!SUM){ return; }
if(summaryPlaced()){ syncSummaryClass(); return; }
var anchor=document.querySelector('#main-cart-footer .totals, .cart__footer .totals')
|| document.querySelector('#main-cart-footer .cart__ctas, .cart__footer .cart__ctas')
|| document.querySelector('.cart__ctas');
if(!anchor || !anchor.parentNode){ SUM.hidden=true; return; }
anchor.parentNode.insertBefore(SUM, anchor); SUM.dataset.placed='1';
if(lastCart){ updateSummary(lastCart); } else { SUM.hidden=false; }
syncSummaryClass();
}
function discountLabel(cart){
var t=null;
if(cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) t=cart.cart_level_discount_applications[0].title;
if(!t && cart.items){ for(var i=0;i<cart.items.length;i++){ var it=cart.items[i];
if(it.line_level_discount_allocations && it.line_level_discount_allocations.length){ var da=it.line_level_discount_allocations[0].discount_application; if(da&&da.title){ t=da.title; break; } }
if(it.discounts && it.discounts.length && it.discounts[0].title){ t=it.discounts[0].title; break; } } }
return t ? ('Discount ('+t+')') : 'Discount';
}
function updateSummary(cart){
if(!SUM){ SUM=document.getElementById('spSummary'); }
var s=SUM; if(!s) return;
var disc=cart.total_discount||0;
var q=function(sel){ return s.querySelector(sel); };
if(q('.sp-sum-sub')) q('.sp-sum-sub').textContent=money(cart.original_total_price);
if(q('.sp-sum-disc-label')) q('.sp-sum-disc-label').textContent=discountLabel(cart);
if(q('.sp-sum-disc')) q('.sp-sum-disc').textContent='\u2212'+money(disc);
if(q('.sp-sum-total')) q('.sp-sum-total').textContent=money(cart.total_price);
var dr=q('.sp-summary__row--disc'); if(dr) dr.hidden = disc<=0;
var hasB=cart.items.some(function(it){ return it.product_type==='Bundle' || (it.handle&&it.handle.indexOf('bundle')>-1); });
if(q('.sp-summary__note')) q('.sp-summary__note').hidden = !(hasB && disc>0);
s.hidden = (cart.item_count===0) || !summaryPlaced();
var st=document.getElementById('spStickyTotal'); if(st) st.textContent=money(cart.total_price);
syncSummaryClass();
}
function paintSummaryFast(newTotal){
var s=document.getElementById('spSummary'); if(!s || s.hidden) return;
var dr=s.querySelector('.sp-summary__row--disc');
if(dr && !dr.hidden) return;
var sub=s.querySelector('.sp-sum-sub'), tot=s.querySelector('.sp-sum-total');
if(sub) sub.textContent=money(newTotal);
if(tot) tot.textContent=money(newTotal);
}
function setCountEl(el,n){
if(!el) return;
var inner=el.querySelector('.cart-count,[class*="count"],[class*="Count"],[class*="bubble"],[class*="Bubble"],span');
(inner||el).textContent=n;
el.classList.remove('hidden','visually-hidden','is-empty','cart-count--empty');
el.removeAttribute('hidden'); el.style.removeProperty('display');
if(n>0){ el.style.removeProperty('opacity'); el.style.removeProperty('visibility'); }
}
function updateHeaderCount(cart){
try{
var n=cart&&typeof cart.item_count==='number'?cart.item_count:null;
if(n===null) return;
var sel=['[data-cart-count]','.cart-count','.cart-count-bubble','[data-sp-cart-count]','.header__cart-count','.cart-link__bubble','.js-cart-count','#cart-icon-bubble .cart-count-bubble','[data-cart-item-count]','.sph__cart-count','.header-cart-count','.cart-badge','.cart__count','[data-cart-count-bubble]'].join(',');
document.querySelectorAll(sel).forEach(function(el){ setCountEl(el,n); });
document.querySelectorAll('a[href="/cart"],a[href^="/cart?"],a[href*="/cart"]').forEach(function(link){
var badge=link.querySelector(BADGESEL);
if(badge){ setCountEl(badge,n); }
});
fetch('/?section_id=cart-icon-bubble',{headers:{'Accept':'text/html'}}).then(function(r){return r.ok?r.text():'';}).then(function(html){
if(!html) return;
try{ var doc=new DOMParser().parseFromString(html,'text/html'); var nb=doc.getElementById('cart-icon-bubble'); var cur=document.getElementById('cart-icon-bubble'); if(cur&&nb){ cur.innerHTML=nb.innerHTML; } }catch(e){}
}).catch(function(){});
document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart:cart}}));
document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
}catch(e){}
}
function paintBackgrounds(cart){
try{
var st=document.getElementById('spBgStyle');
if(!st){ st=document.createElement('style'); st.id='spBgStyle'; document.head.appendChild(st); }
var css='';
var rw=66, rh=95, mt=0;
var ref=null, imgs=document.querySelectorAll('.cart-item__media img, .cart-item__image');
for(var q=0;q<imgs.length;q++){ var ii=imgs[q];
if(ii.complete && ii.naturalHeight>0 && ii.getBoundingClientRect().height>20){ ref=ii; break; } }
if(!ref && imgs.length){ ref=imgs[0]; }
if(ref){ var r=ref.getBoundingClientRect(); if(r.height>20){ rw=Math.round(r.width); rh=Math.round(r.height);
var pc=ref.closest('.cart-item__media,td,.cart-item__image-container');
if(pc){ var pr=pc.getBoundingClientRect(); if(pr.height>0){ mt=Math.max(0,Math.round(r.top-pr.top)); } } } }
(cart.items||[]).forEach(function(it,i){
if(it.featured_image && it.featured_image.url) return;
var s=IMG[it.handle]; if(!s) return; if(typeof s==='string') s=[s];
s=s.filter(function(u){ return typeof u==='string' && u.length>6; });
if(!s.length) return;
var n=i+1, u=s[s.length-1];
css+='#CartItem-'+n+' .cart-item__media{background:url("'+u+'") center center/contain no-repeat;width:'+rw+'px!important;height:'+rh+'px!important;margin-top:'+mt+'px;display:inline-block!important;vertical-align:top;border-radius:8px}#CartItem-'+n+' .cart-item__media img{opacity:0;height:0!important}';
});
st.textContent=css;
}catch(e){}
}
function swapImages(){
document.querySelectorAll(ROWSEL).forEach(function(row){
var link=row.querySelector('a[href*="/products/"]'); if(!link) return;
var h=link.getAttribute('href').split('/products/')[1]; if(!h) return; h=h.split('?')[0].split('/')[0];
var srcs=IMG[h]; if(!srcs) return; if(typeof srcs==='string') srcs=[srcs];
srcs=srcs.filter(function(u){ return typeof u==='string' && u.length>6; });
if(!srcs.length) return;
var img=row.querySelector('.cart-item__image, .cart-item__media img, img'); if(!img || img.getAttribute('data-sp')==='1') return;
var orig=img.getAttribute('src'); img.setAttribute('data-sp','1');
var i=0;
img.onerror=function(){ i++; if(i<srcs.length){ this.src=srcs[i]; return; } this.onerror=null; if(orig){ this.src=orig; } };
img.removeAttribute('srcset'); img.src=srcs[0];
});
}
function paintGiftTotal(row,h){
/* De cadeauregel krijgt zijn bedrag niet uit een rekensom maar rechtstreeks
   uit de instellingen: oude prijs doorgehaald, nul ernaast. Een cadeau kost
   nul, wat er verder ook in de wagen ligt. */
var lt=lineTotalEl(row); if(!lt) return;
var oud=(h===CFG.gift10mlHandle)?CFG.gift10mlWas:CFG.gift3mlWas;
var wil=(oud>0?'<s class="sp-gift-was">'+money(oud)+'</s> ':'')+'<span class="sp-gift-now">'+money(0)+'</span>';
if(lt.innerHTML!==wil) lt.innerHTML=wil;
}
function isGiftRow(row){ return row.classList.contains('sp-gift-line'); }
function tagGiftLines(){
document.querySelectorAll(ROWSEL).forEach(function(row){
var link=row.querySelector('a[href*="/products/"]'); if(!link) return;
var h=link.getAttribute('href').split('/products/')[1]; if(!h) return; h=h.split('?')[0].split('/')[0];
if(h!==CFG.gift10mlHandle && h!==CFG.gift3mlHandle) return;
paintGiftTotal(row,h);
if(!row.classList.contains('sp-gift-line')){
row.classList.add('sp-gift-line');
var nm=row.querySelector('.cart-item__name'); if(nm && !nm.querySelector('.sp-gift-badge')){ var b=document.createElement('span'); b.className='sp-gift-badge'; b.textContent='Gift'; nm.appendChild(b); }
var qi=row.querySelector('.quantity__input, .quantity input, input[name*="updates"]'); if(qi){ qi.setAttribute('readonly',''); qi.setAttribute('tabindex','-1'); }
var qc=row.querySelector('.cart-item__quantity, .cart-item__quantity-wrapper, td.cart-item__quantity'); if(!qc){ var qq=row.querySelector('.quantity, quantity-input'); if(qq) qc=qq.parentNode; } if(!qc) qc=row; if(qc && !row.querySelector('.sp-gift-free')){ var fl=document.createElement('span'); fl.className='sp-gift-free'; fl.textContent='Included \u2014 free'; qc.appendChild(fl); }
}
});
}
function addRuo(){
document.querySelectorAll(ROWSEL).forEach(function(item){
if(item.querySelector('.sp-ruo')) return;
var names=item.querySelectorAll('.cart-item__name'), nm=null, i;
for(i=0;i<names.length;i++){ if((names[i].textContent||'').replace(/\s/g,'').length>1){ nm=names[i]; break; } }
if(!nm) nm=item.querySelector('.cart-item__name'); if(!nm) return;
var r=document.createElement('span'); r.className='sp-ruo'; r.textContent='For research purpose only';
nm.appendChild(r);
});
}
var _vp=false;
function scheduleVisual(){ if(_vp) return; _vp=true;
/* requestAnimationFrame vuurt niet in een tabblad op de achtergrond. Wie de
   winkelwagen op een tweede tabblad openzet, zag daardoor geen cadeaulabel en
   geen doorgehaalde prijs. Er loopt nu ook een gewone teller mee; wie het
   eerst is, doet het werk. */
var gedaan=false;
var run=function(){ if(gedaan) return; gedaan=true; _vp=false; swapImages(); tagGiftLines(); addRuo(); placeTrust(); };
if(window.requestAnimationFrame){ requestAnimationFrame(run); }
setTimeout(run,50);
}
function herstel(){
/* Een keer opnieuw laden, nooit in een lus. Een vlag op window is niet genoeg:
   die gaat bij het herladen verloren, dus een blijvende afwijking zou blijven
   herladen. Daarom onthouden we het voor de duur van het bezoek. */
try{ if(sessionStorage.getItem("spHerstel")) return; sessionStorage.setItem("spHerstel","1"); }
catch(e){ if(window.__spHerstel) return; window.__spHerstel=1; }
location.reload();
}
function markUpdating(on){ try{ document.body.classList[on?'add':'remove']('sp-updating'); }catch(e){} }
function sectieId(){
/* De sectienaam bevat een code die per thema verschilt, dus die lezen we uit
   de pagina in plaats van hem vast te leggen. */
var el=document.getElementById('main-cart-items')||document.querySelector(ROWSEL);
var host=el&&el.closest?el.closest('[id^="shopify-section"]'):null;
return host ? host.id.replace('shopify-section-','') : null;
}
function applySection(id, html){
if(!html) return false;
var cur=document.getElementById(id); if(!cur) return false;
try{
var doc=new DOMParser().parseFromString(html,'text/html');
var neu=doc.getElementById(id); if(!neu) return false;
if(!neu.innerHTML || neu.innerHTML.trim().length<20) return false;
cur.innerHTML=neu.innerHTML; return true;
}catch(e){ return false; }
}
function footerHealthy(){
var f=document.getElementById('main-cart-footer')||document.querySelector('.cart__footer');
if(!f) return true;
return !!(f.querySelector('[name="checkout"], .cart__checkout-button, .cart__ctas'));
}
/* Krijgt softRefresh de verse wagen mee, dan hoeft die niet nog eens
   opgehaald te worden. Scheelt het laatste ritje naar de server. */
function verversCijfers(){
/* De enige bron voor bedragen op het scherm. Een wijzigingsantwoord van
   Shopify kan een totaal bevatten dat nog niet is uitgerekend; /cart.js niet. */
return readCart().then(function(c){
if(!geldigeWagen(c)) return null;
snapshot(c);
/* Passen de rijen niet bij de regels, dan is elk bedrag dat we tonen een gok.
   Een keer opnieuw laden geeft een pagina die wel klopt. */
if(!paintFromCart(c)){ herstel(); return c; }
updateSummary(c); renderDiscounts(c);
return c;
}).catch(function(){ return null; });
}
function softRefresh(vers){
var sid=sectieId();
if(!sid){ location.reload(); return Promise.resolve(false); }
return fetch('/cart?section_id='+encodeURIComponent(sid),{headers:{'Accept':'text/html'}})
.then(function(r){ return r.ok ? r.text() : ''; })
.then(function(html){
var ok=applySection('main-cart-items', html);
placeSummary();
scheduleVisual();
if(!footerHealthy()){ location.reload(); return ok; }
document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
return ok;
})
.then(function(ok){ return verversCijfers().then(function(){ return ok; }); })
.catch(function(){ placeSummary(); location.reload(); });
}
var spUnits=[], spQty=[], spTotal=SP.total, spDisc=SP.disc;
function snapshot(cart){ spUnits=[]; spQty=[]; cart.items.forEach(function(it){ spUnits.push(it.final_price); spQty.push(it.quantity); }); spTotal=cart.total_price; spDisc=cart.total_discount||0; }
function optimSafe(){ return spDisc<=0; }
function rowsArr(){ return Array.prototype.slice.call(document.querySelectorAll(ROWSEL)); }
function lineOf(row){
var m=(row.id||'').match(/(\d+)\s*$/); if(m) return parseInt(m[1],10);
var d=row.querySelector('[data-index]'); if(d && d.getAttribute('data-index')) return parseInt(d.getAttribute('data-index'),10);
var a=row.querySelector('a[href*="line="]'); if(a){ var lm=a.getAttribute('href').match(/line=(\d+)/); if(lm) return parseInt(lm[1],10); }
var i=rowsArr().indexOf(row); return i<0?0:i+1;
}
function lineTotalEl(row){ return row.querySelector('.cart-item__final-price, .cart-item__totals .price, .cart-item__price-wrapper .price'); }
function paintTotals(){ var m=money(spTotal); if(optimSafe()){ document.querySelectorAll('.totals__total-value, .totals__subtotal-value').forEach(function(el){ el.textContent=m; }); var st=document.getElementById('spStickyTotal'); if(st) st.textContent=m; } paintSummaryFast(spTotal); }
function optimQty(row,newQty){
/* Niet op de plek in de pagina koppelen: het script verplaatst de cadeauregel
   naar boven, en dan leest elke rij de cijfers van zijn buurman. lineOf() haalt
   het regelnummer uit de rij zelf. */
var i=lineOf(row)-1; if(i<0||i>=spUnits.length) return;
var unit=spUnits[i], oldQty=spQty[i]; if(unit==null) return;
/* Zit er korting in de wagen, dan valt niet vooruit te rekenen wat een regel
   gaat kosten — dat hangt af van hoe Shopify de korting over de regels verdeelt.
   Even wachten op het echte antwoord is beter dan een verkeerd bedrag tonen. */
if(!optimSafe()) return;
var lt=lineTotalEl(row); if(lt) lt.textContent=money(unit*newQty);
spTotal += unit*(newQty-oldQty); spQty[i]=newQty; paintTotals(); }
function optimRemove(row){
/* Zelfde correctie als in optimQty: koppelen op regelnummer, niet op de plek
   in de pagina. En met korting in de wagen laten we het totaal met rust tot
   de server antwoordt; het aandeel van een regel in een korting valt hier niet
   na te rekenen. De rij vervaagt wel meteen, dat is puur gevoel en geen bedrag. */
var i=lineOf(row)-1;
row.style.transition='opacity .2s ease'; row.style.opacity='.4';
if(i<0||i>=spUnits.length) return;
var unit=spUnits[i], oldQty=spQty[i]; if(unit==null) return;
if(!optimSafe()) return;
spTotal -= unit*oldQty; spQty[i]=0; paintTotals(); }
function handleVanRij(row){
var l=row.querySelector('a[href*="/products/"]'); if(!l) return null;
var h=l.getAttribute('href').split('/products/')[1]; if(!h) return null;
return h.split('?')[0].split('/')[0];
}
function rijenKloppen(cart){
/* De rijen in de pagina en de regels in de wagen moeten een op een op elkaar
   passen. Zo niet, dan is de pagina achterhaald en zegt elk bedrag dat we
   erop schrijven iets over de verkeerde regel. */
if(!cart || !Array.isArray(cart.items)) return false;
var rows=rowsArr();
if(rows.length!==cart.items.length) return false;
for(var i=0;i<rows.length;i++){
var it=cart.items[lineOf(rows[i])-1]; if(!it) return false;
var h=handleVanRij(rows[i]); if(h && it.handle && h!==it.handle) return false;
}
return true;
}
function paintFromCart(cart){
if(!rijenKloppen(cart)) return false;
rowsArr().forEach(function(row){
var it=cart.items[lineOf(row)-1]; if(!it) return;
/* Cadeauregels worden door paintGiftTotal geschilderd, niet met een bedrag
   uit de wagen. */
if(isGiftRow(row)){ var qg=row.querySelector('.quantity__input, .quantity input'); if(qg && String(it.quantity)!==qg.value){ qg.value=it.quantity; } return; }
var lt=lineTotalEl(row); if(lt) lt.textContent=money(it.final_line_price);
var qi=row.querySelector('.quantity__input, .quantity input'); if(qi && String(it.quantity)!==qi.value){ qi.value=it.quantity; }
});
document.querySelectorAll('.totals__total-value').forEach(function(el){ el.textContent=money(cart.total_price); });
document.querySelectorAll('.totals__subtotal-value').forEach(function(el){ el.textContent=money(cart.items_subtotal_price); });
return true;
}
function serverChange(line, qty){ return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})}).then(function(r){ if(!r.ok) throw 0; return r.json(); }); }
function apply(cart){
snapshot(cart);
var _g=giftsFor(cart), v=_g.v, w10=_g.w10, w3=_g.w3;
updateUI(cart,v,w10,w3);
if(!configured) return Promise.resolve();
var need10=qtyOf(cart,CFG.gift10mlHandle)!==w10, need3=qtyOf(cart,CFG.gift3mlHandle)!==w3;
if(!need10 && !need3) return Promise.resolve();
markUpdating(true);
return syncGifts(cart,w10,w3).then(function(vers){
if(!geldigeWagen(vers)){ markUpdating(false); return; }
return softRefresh(vers).then(function(){ markUpdating(false); });
}).catch(function(){ markUpdating(false); });
}
function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
function collectDiscounts(cart){
var map={}, order=[];
(cart.cart_level_discount_applications||[]).forEach(function(d){ var t=d.title||'Discount'; if(map[t]==null){map[t]=0;order.push(t);} map[t]+=d.total_allocated_amount||0; });
(cart.items||[]).forEach(function(it){ (it.line_level_discount_allocations||[]).forEach(function(a){ var t=(a.discount_application&&a.discount_application.title)||'Discount'; if(map[t]==null){map[t]=0;order.push(t);} map[t]+=a.amount||0; }); });
return order.map(function(t){ return {title:t, amount:map[t]}; });
}
function renderDiscounts(cart){
var list=document.querySelector('.sp-disc__list'); if(!list) return;
list.innerHTML=collectDiscounts(cart).map(function(d){
return '<div class="sp-disc__applied"><span>&#10003; '+esc(d.title)+'</span><span>&minus;'+money(d.amount)+'<button type="button" class="sp-disc__x" aria-label="Remove discount">&#10005;</button></span></div>';
}).join('');
}
function discMsg(text,kind){ var m=document.querySelector('.sp-disc__msg'); if(!m) return; m.textContent=text||''; m.className='sp-disc__msg'+(text?(' is-'+kind):''); }
function setDiscount(code){
return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:code})})
.then(function(r){ return r.json(); });
}
function afterDiscountChange(cart){
if(!geldigeWagen(cart)){ softRefresh(); return; }
snapshot(cart); renderDiscounts(cart);
if(!paintFromCart(cart)){ softRefresh(cart); return; }
var _g=giftsFor(cart), v=_g.v, w10=_g.w10, w3=_g.w3;
updateUI(cart,v,w10,w3);
verversCijfers();
}
var busy=false, quiet=0;
function hush(ms){ quiet=Date.now()+(ms||1200); }
function isQuiet(){ return Date.now()<quiet; }
function applyGated(cart){ if(busy) return; busy=true; apply(cart).then(function(){ busy=false; }).catch(function(){ busy=false; markUpdating(false); }); }
function reconcile(){ if(busy) return; busy=true; readCart().then(function(cart){ apply(cart).then(function(){ busy=false; }); }).catch(function(){ busy=false; markUpdating(false); }); }
var undoBox=document.getElementById('spUndo'), undoData=null, undoTimer=null;
function showUndo(item){
if(!undoBox||!item) return;
undoData=item;
var t=undoBox.querySelector('.sp-undo__t'); if(t) t.textContent=(item.product_title||item.title||'Item')+' removed';
undoBox.classList.add('is-on');
clearTimeout(undoTimer); undoTimer=setTimeout(function(){ undoBox.classList.remove('is-on'); undoData=null; },7000);
}
if(undoBox){
undoBox.querySelector('button').addEventListener('click',function(){
if(!undoData) return;
var d=undoData; undoData=null; undoBox.classList.remove('is-on'); hush(2500);
fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
body:JSON.stringify({items:[{id:d.variant_id||d.id,quantity:d.quantity||1,properties:d.properties||undefined}]})})
.then(function(){ return softRefresh(); }).catch(function(){ location.reload(); });
});
}
(function(){
var bar=document.getElementById('spSticky'); if(!bar) return;
var btn=document.getElementById('spStickyBtn');
if(btn) btn.addEventListener('click',function(){
var real=document.querySelector('[name="checkout"], .cart__checkout-button');
if(real){ real.click(); } else { location.href='/checkout'; }
});
function realBtn(){ return document.querySelector('#main-cart-footer [name="checkout"], .cart__footer [name="checkout"], .cart__checkout-button'); }
function tick(){
var r=realBtn(); if(!r){ bar.classList.remove('is-on'); return; }
var box=r.getBoundingClientRect();
var offscreen = box.top > (window.innerHeight - 40);
bar.classList[offscreen?'add':'remove']('is-on');
}
window.addEventListener('scroll',tick,{passive:true});
window.addEventListener('resize',tick);
setInterval(tick,1000); tick();
})();
var df=document.querySelector('.sp-disc');
if(df){
var inp=df.querySelector('.sp-disc__row input');
var applyBtn=df.querySelector('.sp-disc__row button');
var applyCode=function(){
var code=(inp&&inp.value||'').trim();
if(!code){ if(inp) inp.focus(); discMsg('Enter a discount code.','err'); return; }
if(applyBtn){ applyBtn.disabled=true; applyBtn.textContent='Applying\u2026'; }
discMsg('','');
hush(2500);
setDiscount(code).then(function(cart){
var ok=(cart.total_discount||0)>0;
if(ok){ if(inp) inp.value=''; discMsg('Discount applied.','ok'); }
else { discMsg('That code isn\u2019t valid for the items in your cart.','err'); }
afterDiscountChange(cart);
}).catch(function(){ discMsg('Something went wrong. Please try again.','err'); })
.then(function(){ if(applyBtn){ applyBtn.disabled=false; applyBtn.textContent='Apply'; } });
};
df.addEventListener('click',function(e){
var x=e.target.closest('.sp-disc__x');
if(x){
e.preventDefault(); x.disabled=true; x.textContent='\u2026'; hush(2500);
setDiscount('').then(function(cart){
discMsg('Discount removed.','ok');
afterDiscountChange(cart);
setTimeout(function(){ discMsg('',''); },2500);
}).catch(function(){ x.disabled=false; x.textContent='\u2715'; discMsg('Could not remove the discount.','err'); });
return;
}
if(e.target.closest('.sp-disc__row button')){ e.preventDefault(); applyCode(); }
});
if(inp) inp.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.keyCode===13){ e.preventDefault(); applyCode(); } });
}
(function(){
var of=window.fetch;
if(of && !window.__spCartHook){
window.__spCartHook=1;
window.fetch=function(){
var a=arguments,u='';
try{ u=(typeof a[0]==='string')?a[0]:((a[0]&&a[0].url)||''); }catch(e){}
var pr=of.apply(this,a);
if(/\/cart\/(change|update|add|clear)/.test(u)){ pr.then(function(){ setTimeout(function(){ if(!busy && !isQuiet()) reconcile(); },160); }).catch(function(){}); }
return pr;
};
}
})();
reconcile();
(function(){
var tries=0, iv=setInterval(function(){
placeSummary();
var s=SUM||document.getElementById('spSummary');
if(++tries>20 || (s && s.dataset.placed)) clearInterval(iv);
},250);
var sick=0;
setInterval(function(){
if(!summaryPlaced()){ placeSummary(); }
syncSummaryClass();
if(!footerHealthy()){ if(++sick>=2){ sick=0; location.reload(); } } else { sick=0; }
},1200);
var foot=document.getElementById('main-cart-footer')||document.querySelector('.cart__footer');
if(foot){ new MutationObserver(function(){ placeSummary(); }).observe(foot,{childList:true,subtree:true}); }
})();
var box=document.querySelector('.cart__items, #main-cart-items, cart-items, .cart-items, .cart__contents, .js-contents');
if(box){
var t;
new MutationObserver(function(){
if(isQuiet()) return;
scheduleVisual();
clearTimeout(t); t=setTimeout(function(){ if(!busy && !isQuiet()) reconcile(); },300);
}).observe(box,{childList:true,subtree:true});
var chain=Promise.resolve();
function commit(row, line, qty, removing){
hush(2000);
chain = chain.then(function(){
return serverChange(line, qty).then(function(cart){
if(!geldigeWagen(cart)){ return softRefresh(); }
if(removing || qty===0){ if(row && row.parentNode) row.parentNode.removeChild(row); }
if(cart.item_count===0){ location.reload(); return; }
snapshot(cart);
if(!paintFromCart(cart)){ return softRefresh(cart); }
var _g=giftsFor(cart), v=_g.v, w10=_g.w10, w3=_g.w3;
var need = configured && (qtyOf(cart,CFG.gift10mlHandle)!==w10 || qtyOf(cart,CFG.gift3mlHandle)!==w3);
if(need){ return apply(cart); }
updateUI(cart,v,w10,w3);
return verversCijfers();
});
}).catch(function(){ location.reload(); });
return chain;
}
box.addEventListener('change', function(e){
var qi=e.target&&e.target.closest?e.target.closest('.quantity__input, .quantity input, input[name*="updates"]'):null; if(!qi) return;
var row=qi.closest('.cart-item, tr.cart-item'); if(!row||row.classList.contains('sp-gift-line')) return;
var nq=parseInt(qi.value,10); if(isNaN(nq)||nq<0) return;
var line=lineOf(row); if(!line) return;
e.stopImmediatePropagation(); if(e.preventDefault) e.preventDefault();
optimQty(row,nq);
commit(row, line, nq, nq===0);
}, true);
box.addEventListener('click', function(e){
var rm=e.target&&e.target.closest?e.target.closest('cart-remove-button, .cart-remove-button, .button--tertiary, a[href*="quantity=0"]'):null; if(!rm) return;
var row=rm.closest('.cart-item, tr.cart-item'); if(!row||row.classList.contains('sp-gift-line')) return;
var line=lineOf(row); if(!line) return;
e.stopImmediatePropagation(); e.preventDefault();
var snap = lastCart && lastCart.items ? lastCart.items[line-1] : null;
row.style.pointerEvents='none'; optimRemove(row);
commit(row, line, 0, true).then(function(){ if(snap) showUndo(snap); });
}, true);
}
})();
